/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  shared app actions
 */

import { createAction } from 'redux-actions'
import { REQUEUE } from '../constants'

export const requeue = createAction<
  { callback: IdleRequestCallback; name: string; options: { before?: number } },
  typeof REQUEUE
>(REQUEUE)
